import React from 'react';
import { Box, Typography } from '@mui/material';
import { PRIMARY_LIGHT } from '../../theme';
import { EMOJI_GROUPS } from './chatHelpers';

/** A compact, self-contained emoji grid (no external picker dependency) used
 * to insert emoji into the message composer and to pick a reaction beyond
 * the six quick-reaction shortcuts. Mirrors the role schoolmate's
 * emoji-picker-react plays there, restyled to this app's own tokens. */
export default function EmojiPickerPanel({ onSelect, width = 300, height = 280 }) {
    return (
        <Box sx={{ width, height, overflowY: 'auto', p: 1.2, bgcolor: '#fff' }}>
            {EMOJI_GROUPS.map((group) => (
                <Box key={group.label} sx={{ mb: 1 }}>
                    <Typography sx={{ fontSize: 10.5, fontWeight: 800, color: '#98A0AE', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5, px: 0.3 }}>
                        {group.label}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {group.emojis.map((emj) => (
                            <Box
                                key={emj}
                                role="button"
                                tabIndex={0}
                                onClick={() => onSelect(emj)}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(emj); } }}
                                sx={{
                                    width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 18, borderRadius: '7px', cursor: 'pointer', userSelect: 'none',
                                    '&:hover': { bgcolor: PRIMARY_LIGHT },
                                }}
                            >
                                {emj}
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
